var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialLink3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "var(--gray-40)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_1253)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_413_1253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.2307H16V5.23071H14V10.2307ZM9 10.2307H11V5.23071H9V10.2307ZM19 11.5378V2.23071H5V14.2307H9V17.1838L11.56 14.2307H16.34L19 11.5378ZM15.907 17.2307H11.993L9.387 20.2307H7V17.2307H2V3.71069L3.3 0.230713H21V12.4036L15.907 17.2307Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_1253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4615,
    height: 20.4615,
    fill: "white",
    transform: "translate(0.769531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_413_1253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white",
    transform: "translate(2 0.230713)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLink3);
export default __webpack_public_path__ + "static/media/social-link-3.6f5f8824fab686e2ba155300eba89afd.svg";
export { ForwardRef as ReactComponent };